import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {ConnectionService} from "./connection.service";
import {Observable} from "rxjs/Observable";
import {Calendar} from "../entities/Calendar";
import {Resource} from "../entities/Resource";
import {AppConfig} from "../app.config";
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class CalendarService {

  private readonly apiUrl: string;

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(private http: Http,
              private connectionService: ConnectionService,
              private config : AppConfig,
              private requestInterceptor: RequestInterceptor) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }

  getCalendar(resourceNo : string): Observable<Calendar> {
    return this.requestInterceptor
      .get(this.apiUrl + 'api/Calendar/' + resourceNo, this.getHeaders())
      .map(response => response.json() as Calendar);
  }

  getCalendarForAll(resourceNos : Resource[]): Observable<Calendar> {
    let url = this.apiUrl + 'api/Calendar/Calenders?';
    resourceNos.forEach(x => url += 'resourceIds=' +  x.No + '&');

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Calendar);
  }

  getCalendarForAllForJob(resourceNos : Resource[], jobNo : string): Observable<Calendar> {
    let url = this.apiUrl + 'api/Calendar/Calenders?';
    resourceNos.forEach(x => url += 'resourceIds=' +  x.No + '&');
    url += 'jobNo=' + jobNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Calendar);
  }

  getCalendarForAllForTask(resourceNos : Resource[], taskNo : string): Observable<Calendar> {
    let url = this.apiUrl + 'api/Calendar/Calenders?';
    resourceNos.forEach(x => url += 'resourceIds=' +  x.No + '&');
    url += 'taskNo=' + taskNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Calendar);
  }
}






// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/calendar.service.ts